import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, finalize, tap } from 'rxjs/operators';
import { LoggerProvider } from '@shared';
import { InvestigationFormRepository } from '../../../infrastructure/repositories/investigation-form.repository';
import { InvestigationFormState } from '../../states/investigation-form.state';
import { PublishDraftQuery } from './publish-draft.query';

@Injectable({ providedIn: 'root' })
export class PublishDraftUseCase {
  private readonly _repository = inject(InvestigationFormRepository);
  private readonly _state = inject(InvestigationFormState);
  private readonly _logger = inject(LoggerProvider).createScoped('PublishDraftUseCase');

  public execute(query: PublishDraftQuery): Observable<{ versionId: string }> {
    this._state.setLoadingInvestigationForm(true);
    this._state.clearErrorInvestigationForms();

    return this._repository.publishDraft(query.formId).pipe(
      tap((result) => this._logger.info('Published draft version', { versionId: result.versionId })),
      catchError((error) => {
        const errorMessage =
          error?.error?.message ||
          error?.message ||
          `Failed to publish draft for form ${query.formId}`;
        this._state.setErrorInvestigationForms(errorMessage);
        return throwError(() => error);
      }),
      finalize(() => this._state.setLoadingInvestigationForm(false))
    );
  }
}
